import React, { useEffect, useState } from 'react';

/**
 * MultinetTanisma: Multinet Up tanışma sunumu + dışarıdan dijital denetim.
 * Route: /r/multinet-tanisma (sidebar YOK, tam ekran slayt, 18 slayt 16:9).
 * Yeniden üretmek için: node src/pages/multinet-tanisma/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~68KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function MultinetTanisma() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./multinetTanismaHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Multinet Up · Dışarıdan Bakınca"
      srcDoc={html}
      style={fill}
    />
  );
}
